import Joi from 'joi'
import errorsResolver from '../../../../validation/schemeUtils'
import {nonCashValidate} from "../../../../validation/scheme/nonCash";

const closeSchema = Joi.object({
    "": Joi.any(),
    deals: Joi.array().items(
        Joi.object({
            dealId: Joi.number(),
            ticketLost: Joi.bool(),
            isInterestAmountForgiven: Joi.any(),
            isPenaltyAmountForgiven: Joi.any(),
        })
    ),
    deposit: nonCashValidate,
    closureDate: Joi.date()
        .iso()
        .error(errorsResolver({
            dateFormat: `Некорректная дата`,
        })),
})

export default closeSchema
